import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass";

var Status = /*#__PURE__*/function () {
  function Status(provider, status) {
    var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    _classCallCheck(this, Status);

    this.provider = provider;
    this.status = status;
    this.message = message;
  }

  _createClass(Status, [{
    key: "has",
    value: function has(provider) {
      return provider.prototype.constructor.name === this.provider.constructor.name;
    }
  }, {
    key: "getProvider",
    value: function getProvider() {
      return this.provider;
    }
  }, {
    key: "setProvider",
    value: function setProvider(provider) {
      this.provider = provider;
    }
  }, {
    key: "isStatus",
    value: function isStatus() {
      return this.status;
    }
  }, {
    key: "setStatus",
    value: function setStatus(status) {
      this.status = status;
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      return this.message;
    }
  }, {
    key: "setMessage",
    value: function setMessage(message) {
      this.message = message;
    }
  }]);

  return Status;
}();

export default Status;